/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check': {
    width: 500,
    height: 500,
    viewBox: '0 0 500 500',
    data: '<path pid="0" _fill="#1B1625" d="M169.997 361.656l-112-112-37.333 37.334 149.333 149.333 320-320-37.333-37.333z"/>'
  }
})
